import React from 'react'
import Moment from 'react-moment'
import { validations, validateCase as vCase, isRequire, isNumeric } from 'core/validate'
import xType from 'xtypejs'
import { StatusTag, DivText } from './styled'
import { stringToFunction } from 'core/utilities'
import r from 'reactotron-react-js'

export const slColumns = (companyOptions = []) => {
  const getCompanyName = (code) => {
    var comp = companyOptions.find(c => c.value === code)
    return comp ? comp.text.replace(`${code} : `, '') : code
  } 

  return [
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell: row => (<DivText><StatusTag status={row.value}>{row.original.statusName}</StatusTag></DivText>)
    }, {
      Header: 'Doc No.',
      accessor: 'documentNumber',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    }, {
      Header: () => (<DivText left>Title</DivText>),
      accessor: 'title',
      width: 250
    }, {
      Header: 'Company',
      accessor: 'company',
      width: 100,
      Cell: row => (getCompanyName(row.value || ''))
    }, {
      Header: 'Current Activity',
      accessor: 'currentActivity',
      width: 70,
    }, {
      Header: () => (<DivText left>Requester</DivText>),
      accessor: 'requester',
      width: 100,
      Cell: row => (row.value && <DivText left>{`${row.value || '-'}`}</DivText>)
    }, {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ]
}

export const preQAttribute = {
  yearEstablished: {
    title: 'จำนวนปีที่ก่อตั้งบริษัท (ปี)',
    maxScore: 10,
    formula: 'pre_q_part_a_year_score'
  },
  bankLoan: {
    title: 'สินเชื่อทางธนาคาร (มี = 5 / ไม่มี = 0)',
    maxScore: 5,
    formula: 'pre_q_part_a_bank_loan'
  },
  registeredCapital: {
    title: 'ทุนจดทะเบียน',
    maxScore: 10,
    formula: 'pre_q_part_a_registered_capital'
  },
  paidUpCapital: {
    title: 'ทุนจดทะเบียนชำระแล้ว',
    maxScore: 10,
    formula: 'pre_q_part_a_paid_up_capital'
  },
  incomes: {
    title: 'รายรับ (ย้อนหลัง 3-5 ปี)',
    maxScore: 10,
    formula: 'pre_q_part_a_income'
  },
  capitalRatio: {
    title: 'Current ratio อัตราส่วนทุนหมุนเวียน (เท่า)',
    maxScore: 10,
    formula: 'pre_q_part_a_capital_ratio'
  },
  profits: {
    title: 'กำไร/ขาดทุน (ย้อนหลัง 3-5 ปี)',
    maxScore: 10,
    formula: 'pre_q_part_a_profit'
  },
  shareholders: {
    title: 'ส่วนของผู้ถือหุ้น (ย้อนหลัง 3-5 ปี)',
    maxScore: 10,
    formula: 'pre_q_part_a_share_holder'
  },
  summary: {
    score: {
      title: 'Score',
      value: 235
    },
    percentage: {
      title: 'Percentage',
      value: '100%'
    },
    result: {
      title: 'Result'
    }
  }
}

export const validateGeneralForm = (valueForm, errors) => {
  validations(valueForm, 'title', [vCase.require], errors)
  validations(valueForm, 'companyCode', [vCase.require], errors)
  validations(valueForm, 'projectId', [vCase.require], errors)
  validations(valueForm, 'typeOfTender', [vCase.require], errors)
  validations(valueForm, 'works', [vCase.require], errors)
  validations(valueForm, 'requesterUser', [vCase.require], errors)
  validations(valueForm, 'effectiveDate', [vCase.require], errors)
  validations(valueForm, 'draftBudget', [vCase.require, vCase.number], errors)
  validations(valueForm, 'projectStartTime', [vCase.require], errors)
  validations(valueForm, 'projectEndTime', [vCase.require], errors)

  return errors
}

export const validateVendorForm = (vendors, errors) => {
  if (vendors.length < 3) {
    errors.vendorErrorMessage = 'Vendor is require 3-10 vendors.'
  } else {
    errors.vendors = []
    var emptyVendorErrorCount = 0
    vendors.forEach((v, index) => {
      errors.vendors.push({})
      errors.vendors[index].incomes = []
      errors.vendors[index].profits = []
      errors.vendors[index].shareholders = []
      var emptyIncomeCount = 0
      var emptyProfitCount = 0
      var emptyShareholderCount = 0

      if (v.contacts === undefined || v.contacts === null || (v.contacts || []).length === 0) {
        errors.vendors[index].contacts = 'Require!'
      }

      if (!isRequire(v.address)) errors.vendors[index].address = 'Require!'
      if (!isRequire(v.proposeBy)) errors.vendors[index].proposeBy = 'Require!'
      if (!isRequire(v.yearEstablished)) {
        errors.vendors[index].yearEstablished = 'Require!'
      } else {
        if (!isNumeric(`${v.yearEstablished}`)) errors.vendors[index].yearEstablished = 'Numeric Only!'
      }
      if (!isRequire(v.registeredCapital)) {
        errors.vendors[index].registeredCapital = 'Require!'
      } else {
        if (!isNumeric(`${v.registeredCapital}`)) errors.vendors[index].registeredCapital = 'Numeric Only!'
      }

      const statementIsRequire = (value) => (value === 0 || value === '' || value === '0' || value === null || value === undefined)

      v.incomes.forEach((income, i) => {
        errors.vendors[index].incomes.push({})
        if (statementIsRequire(income.value)) errors.vendors[index].incomes[i].value = 'Require!'

        if (xType(errors.vendors[index].incomes[i]) === 'empty_object') {
          delete errors.vendors[index].incomes[i]
          emptyIncomeCount += 1
        }
      })

      v.profits.forEach((profit, i) => {
        errors.vendors[index].profits.push({})
        if (statementIsRequire(profit.value)) errors.vendors[index].profits[i].value = 'Require!'

        if (xType(errors.vendors[index].profits[i]) === 'empty_object') {
          delete errors.vendors[index].profits[i]
          emptyProfitCount += 1
        }
      })
      
      v.shareholders.forEach((shareholder, i) => {
        errors.vendors[index].shareholders.push({})
        if (statementIsRequire(shareholder.value)) errors.vendors[index].shareholders[i].value = 'Require!'
        
        if (xType(errors.vendors[index].shareholders[i]) === 'empty_object') {
          delete errors.vendors[index].shareholders[i]
          emptyShareholderCount += 1
        }
      })

      if (emptyIncomeCount === 5) delete errors.vendors[index].incomes
      if (emptyProfitCount === 5) delete errors.vendors[index].profits
      if (emptyShareholderCount === 5) delete errors.vendors[index].shareholders

      if (xType(errors.vendors[index]) === 'empty_object') {
        delete errors.vendors[index]
        emptyVendorErrorCount += 1
      }
    })

    if (errors.vendors.length === emptyVendorErrorCount) {
      delete errors.vendors
    }
  }

  return errors
}

export const validatePreQForm = (pqs, errors) => {
  const validatePqValue = (value) => (value === '' || value === null || value === undefined)

  errors.pqs = []
  var emptyPqsErrorCount = 0
  pqs.forEach((pq, index) => {
    errors.pqs.push({})
    errors.pqs[index].incomes = []
    errors.pqs[index].capitalRatios = []
    errors.pqs[index].profits = []
    errors.pqs[index].shareholders = []
    var emptyIncomeCount = 0
    var emptyCapitalRatiosCount = 0
    var emptyProfitCount = 0
    var emptyShareholderCount = 0

    if (validatePqValue(pq.numberOfYearEstablished)) {
      errors.pqs[index].numberOfYearEstablished = 'Require!'
    }

    if (validatePqValue(pq.bankLoan)) {
      errors.pqs[index].bankLoan = 'Require!'
    }

    if (validatePqValue(pq.bankLoan)) {
      errors.pqs[index].bankLoan = 'Require!'
    }

    if (validatePqValue(pq.registeredCapital)) {
      errors.pqs[index].registeredCapital = 'Require!'
    }

    if (validatePqValue(pq.paidUpCapital)) {
      errors.pqs[index].paidUpCapital = 'Require!'
    }

    pq.incomes.forEach((x, i) => {
      errors.pqs[index].incomes.push({})
      if (validatePqValue(x.value)) errors.pqs[index].incomes[i].value = 'Require!'

      if (xType(errors.pqs[index].incomes[i]) === 'empty_object') {
        delete errors.pqs[index].incomes[i]
        emptyIncomeCount += 1
      }
    })

    pq.capitalRatios.forEach((x, i) => {
      errors.pqs[index].capitalRatios.push({})
      if (validatePqValue(x.value)) errors.pqs[index].capitalRatios[i].value = 'Require!'

      if (xType(errors.pqs[index].capitalRatios[i]) === 'empty_object') {
        delete errors.pqs[index].capitalRatios[i]
        emptyCapitalRatiosCount += 1
      }
    })

    pq.profits.forEach((x, i) => {
      errors.pqs[index].profits.push({})
      if (validatePqValue(x.value)) errors.pqs[index].profits[i].value = 'Require!'

      if (xType(errors.pqs[index].profits[i]) === 'empty_object') {
        delete errors.pqs[index].profits[i]
        emptyProfitCount += 1
      }
    })

    pq.shareholders.forEach((x, i) => {
      errors.pqs[index].shareholders.push({})
      if (validatePqValue(x.value)) errors.pqs[index].shareholders[i].value = 'Require!'

      if (xType(errors.pqs[index].shareholders[i]) === 'empty_object') {
        delete errors.pqs[index].shareholders[i]
        emptyShareholderCount += 1
      }
    })

    if (emptyIncomeCount === 5) delete errors.pqs[index].incomes
    if (emptyCapitalRatiosCount === 5) delete errors.pqs[index].capitalRatios
    if (emptyProfitCount === 5) delete errors.pqs[index].profits
    if (emptyShareholderCount === 5) delete errors.pqs[index].shareholders

    if (xType(errors.pqs[index]) === 'empty_object') {
      delete errors.pqs[index]
      emptyPqsErrorCount += 1
    }
  })

  if (errors.pqs.length === emptyPqsErrorCount) {
    delete errors.pqs
  }
  
  return errors
}

export const validateCommitteeForm = (committees, errors) => {
  if (committees.length === 0) {
    errors.committeeErrorMessage = 'Require!'
  } else {
    var isAllEmpty = true
    committees.forEach(c => {
      if (c.username !== null && c.username !== undefined && c.username !== '') { 
        isAllEmpty = false 
      }
    })

    if (isAllEmpty) {
      errors.committeeErrorMessage = 'Require!'
    }
  }

  return errors
}

export const convertVendorDataToPQ = (v, preQFormulas) => {

  const calculateScore = (formulaName, value) => {
    var result = 0
    var formula = preQFormulas.data.find(f => f.name === formulaName)
    
    if (formula) {
      var fn = stringToFunction(formula.formula)
      if (fn) {
        result = fn(value)
      }
    }

    return result
  }

  var result = {}
  var currentYear = (new Date()).getFullYear()
  currentYear = currentYear < 2500 ? currentYear + 543 : currentYear

  result.vendorCode = v.vendorCode
  result.numberOfYearEstablished = currentYear - v.yearEstablished
  result.bankLoan = 0
  result.registeredCapital = v.registeredCapital
  result.paidUpCapital = 0
  result.incomes = v.incomes.map(x => ({ year: x.year, value: x.value, score: calculateScore(preQAttribute.incomes.formula, x.value) }))
  result.capitalRatios = v.incomes.map(x => ({ year: x.year, value: 0, score: 0 }))
  result.profits = v.profits.map(x => ({ year: x.year, value: x.value, score: calculateScore(preQAttribute.profits.formula, x.value) }))
  result.shareholders = v.shareholders.map(x => ({ year: x.year, value: x.value, score: calculateScore(preQAttribute.shareholders.formula, x.value) }))
  result.experience = v.experience || []
  result.numberOfYearEstablishedScore = calculateScore(preQAttribute.yearEstablished.formula, result.numberOfYearEstablished)
  result.bankLoanScore = 0
  result.registeredCapitalScore = calculateScore(preQAttribute.registeredCapital.formula, result.registeredCapital)
  result.paidUpCapitalScore = 0

  var totalScore = 0
  totalScore += Number(result.numberOfYearEstablishedScore)
  totalScore += Number(result.bankLoanScore)
  totalScore += Number(result.registeredCapitalScore)
  totalScore += Number(result.paidUpCapitalScore)
  result.incomes && result.incomes.forEach(x => { totalScore += Number(x.score) })
  result.capitalRatios && result.capitalRatios.forEach(x => { totalScore += Number(x.score) })
  result.profits && result.profits.forEach(x => { totalScore += Number(x.score) })
  result.shareholders && result.shareholders.forEach(x => { totalScore += Number(x.score) })

  var percentage = (totalScore / preQAttribute.summary.score.value) * 100

  result.score = totalScore
  result.percentage = percentage.toFixed(2)
  result.result = ''

  return result
}

export const updatePqValueFromVendor = (pq, v, preQFormulas) => {

  const calculateScore = (formulaName, value) => {
    var result = 0
    var formula = preQFormulas.data.find(f => f.name === formulaName)
    
    if (formula) {
      var fn = stringToFunction(formula.formula)
      if (fn) {
        result = fn(value)
      }
    }

    return result
  }

  var currentYear = (new Date()).getFullYear()
  currentYear = currentYear < 2500 ? currentYear + 543 : currentYear

  pq.numberOfYearEstablished = currentYear - v.yearEstablished
  pq.registeredCapital = v.registeredCapital
  pq.incomes = v.incomes.map(x => ({ year: x.year, value: x.value, score: calculateScore(preQAttribute.incomes.formula, x.value) }))
  pq.profits = v.profits.map(x => ({ year: x.year, value: x.value, score: calculateScore(preQAttribute.profits.formula, x.value) }))
  pq.shareholders = v.shareholders.map(x => ({ year: x.year, value: x.value, score: calculateScore(preQAttribute.shareholders.formula, x.value) }))
  pq.experience = v.experience || []
  pq.numberOfYearEstablishedScore = calculateScore(preQAttribute.yearEstablished.formula, pq.numberOfYearEstablished)
  pq.registeredCapitalScore = calculateScore(preQAttribute.registeredCapital.formula, pq.registeredCapital)

  var totalScore = 0
  totalScore += Number(pq.numberOfYearEstablishedScore)
  totalScore += Number(pq.bankLoanScore)
  totalScore += Number(pq.registeredCapitalScore)
  totalScore += Number(pq.paidUpCapitalScore)
  pq.incomes && pq.incomes.forEach(x => { totalScore += Number(x.score) })
  pq.capitalRatios && pq.capitalRatios.forEach(x => { totalScore += Number(x.score) })
  pq.profits && pq.profits.forEach(x => { totalScore += Number(x.score) })
  pq.shareholders && pq.shareholders.forEach(x => { totalScore += Number(x.score) })

  var percentage = (totalScore / preQAttribute.summary.score.value) * 100

  pq.score = totalScore
  pq.percentage = percentage.toFixed(2)
  pq.result = ''

  return pq
}